// extracted by mini-css-extract-plugin
export default {"directoryCardContainer":"DirectoryCardArea_directoryCardContainer__36Vpz","fillColor":"DirectoryCardArea_fillColor__D7j3m"};